import React from 'react';
import { ShieldCheckIcon, StarIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { CHECKOUT_URL, PRODUCT_IMG } from './constants';
export function FinalCTA() {
  return <section className="border-t border-ink-line bg-ink-panel px-4 py-8" data-id="element-43" data-mp="c7adc3u6m4g0">
      <div className="mx-auto max-w-3xl text-center" data-id="element-44" data-mp="c4fw0l6gszqt">
        <h2 className="text-xl font-extrabold sm:text-3xl" data-id="element-45" data-mp="84e2izavvcmm">One Last Chance</h2>
        <div className="mx-auto mt-2 max-w-2xl space-y-1.5 text-sm leading-snug text-ink-text sm:text-base" data-id="element-46" data-mp="m46q4lr45cqd">
          <p data-id="element-47" data-mp="h4u4u5fw4dpw">Your patients deserve more than therapy sessions prepared at the last minute.</p>
          <p data-id="element-48" data-mp="vv1fhyznosg1">
            Stop spending hours creating activities, writing treatment goals, searching for
            worksheets, organizing documentation, preparing printable resources, and
            reinventing every therapy session.
          </p>
          <p data-id="element-49" data-mp="14t3j8marxz70">
            Instead, work with confidence using one complete professional operating system that
            gives you everything already planned, organized, and ready to use.
          </p>
          <p className="font-semibold text-white" data-id="element-50" data-mp="2c711ry75kpuv">
            Spend less time preparing. Spend more time helping your patients communicate with
            confidence.
          </p>
          <p data-id="element-51" data-mp="2m4xa6i8ph6pa">
            Deliver more organized, effective, and professional therapy sessions with a system
            built specifically for experienced Speech Therapists.
          </p>
        </div>

        <div className="mt-4 rounded-2xl border border-gold/60 bg-ink-bg p-5" data-id="element-52" data-mp="2v1fzlkhqach4">
          <a href={CHECKOUT_URL} className="block" aria-label="Buy Speech Therapy Pro" data-id="element-53" data-mp="30111o3s730y2">
            <img src={PRODUCT_IMG} alt="Speech Therapy Pro complete system with bonuses" className="mx-auto mb-3 w-full max-w-[220px] rounded-lg transition-transform duration-200 hover:scale-[1.02]" data-id="element-54" data-mp="34un1gvd9facg" />
          </a>
          <h3 className="text-base font-extrabold sm:text-xl" data-id="element-55" data-mp="3etcn8z8a1exz">🗣️ Speech Therapy Pro™</h3>
          <p className="text-xs text-ink-text sm:text-sm" data-id="element-56" data-mp="3itmro7gf7xaq">
            Complete 6-in-1 Operating System + 5 Premium Bonuses
          </p>
          <p className="mt-2 text-sm text-ink-text line-through sm:text-base" data-id="element-57" data-mp="1ep8pzqmll87s">
            Regular Price: $97
          </p>
          <p className="mt-1 font-display text-3xl font-extrabold text-gold sm:text-4xl" data-id="element-58" data-mp="1sh6tnlxjibwk">
            Today Only: $27 USD
          </p>

          <CTAButton href={CHECKOUT_URL} className="mt-4" data-id="element-59" data-mp="1nodowy22n3kh">
            🚀 YES! I WANT MY SPEECH THERAPY PRO™ SYSTEM
          </CTAButton>

          <p className="mt-2 text-xs text-ink-text sm:text-sm" data-id="element-60" data-mp="1xfqh5qrs7vr1">
            Immediate Access • Delivered Instantly by Email
          </p>
          <div className="mt-2 flex flex-col items-center gap-1 text-[11px] text-ink-text sm:flex-row sm:justify-center sm:gap-4 sm:text-sm" data-id="element-61" data-mp="2behq6yrser8b">
            <span className="flex items-center gap-1.5" data-id="element-62" data-mp="27bte8i7s1474">
              <StarIcon className="h-4 w-4 fill-gold text-gold" aria-hidden="true" data-id="element-63" data-mp="h2jf0r9x3l9s" />⭐ 4.9/5 —
              Verified Therapist Reviews
            </span>
            <span className="flex items-center gap-1.5" data-id="element-64" data-mp="d298ndi7qsue">
              <ShieldCheckIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-65" data-mp="2x9hhm9l9llj" />
              🛡️ 7-Day Money-Back Guarantee — Zero Risk
            </span>
          </div>
        </div>
      </div>
    </section>;
}